import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes as RouterRoutes } from 'react-router-dom';
import LandingContainer from './LandingContainer';

const Menu = lazy(() => import('./Menu/Menu'));
const Partners = lazy(() => import('./Partners/Partners'));
const NotFound = lazy(() => import('./NotFound/NotFound'));

const Routes = () => (
  <BrowserRouter basename="/">
    <Suspense fallback={null}>
      <RouterRoutes>
        <Route path="/" element={<LandingContainer />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/partners/:partnerUuid" element={<Partners />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </Suspense>
  </BrowserRouter>
);

export default Routes;
